import { useState, useEffect } from 'react'

const variants = {
  gold: {
    outer: 'linear-gradient(to bottom, #917100, #EAD98F)',
    inner: 'linear-gradient(to bottom, #FFFDDD, #856807, #FFF1B3)',
    face: 'linear-gradient(to bottom, #FFEBA1, #9B873F)',
    textColor: '#FFFDE5',
    textShadow: '0 -1px 0 rgb(178 140 2 / 100%)',
  },
  default: {
    outer: 'linear-gradient(to bottom, #000, #A0A0A0)',
    inner: 'linear-gradient(to bottom, #FAFAFA, #3E3E3E, #E5E5E5)',
    face: 'linear-gradient(to bottom, #B9B9B9, #969696)',
    textColor: '#ffffff',
    textShadow: '0 -1px 0 rgb(80 80 80 / 100%)',
  },
}

export function PolicyLinkedBadge({ linked }) {
  const v = linked ? variants.gold : variants.default
  const [isTouchDevice, setIsTouchDevice] = useState(false)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0)
  }, [])

  return (
    <div
      className="relative inline-flex rounded"
      style={{
        padding: '1.25px',
        background: v.outer,
        boxShadow: hovered && !isTouchDevice
          ? '0 3px 8px rgba(0,0,0,0.18)'
          : '0 2px 5px rgba(0,0,0,0.10)',
        transition: 'box-shadow 200ms ease',
      }}
      onMouseEnter={() => !isTouchDevice && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* inner glow ring */}
      <div
        className="absolute inset-[1px] rounded pointer-events-none"
        style={{ background: v.inner }}
      />
      {/* button face */}
      <div
        className="relative z-10 m-[1px] rounded flex items-center justify-center px-2 py-0.5 text-xs font-semibold leading-none select-none"
        style={{
          background: v.face,
          color: v.textColor,
          textShadow: v.textShadow,
          filter: hovered && !isTouchDevice ? 'brightness(1.08)' : 'none',
          transition: 'filter 200ms ease',
          minWidth: '2.5rem',
        }}
      >
        {linked ? '✓ Linked' : '✗'}
      </div>
    </div>
  )
}
